/**
 * Tax ID (EIN/SSN) validation for Stedi provider linking.
 * Both EIN and SSN must be exactly 9 digits (digits only, no dashes).
 * @see Stedi API constraint: ^\d{9}$
 */

const TAX_ID_DIGITS_REGEX = /^\d{9}$/;

/**
 * Extracts digits from a tax ID string (handles formats like XX-XXXXXXX or XXX-XX-XXXX).
 */
export function getTaxIdDigits(value: string | null | undefined): string {
    return value?.replace(/\D/g, '') ?? '';
}

/**
 * Validates a Tax ID (EIN or SIN) for Stedi API compatibility.
 * Must be exactly 9 digits.
 * @param value - The tax ID value (string, may include dashes)
 * @returns true if valid (empty or exactly 9 digits)
 */
export function taxIdValid(value: string | number | null | undefined): boolean {
    const digits = getTaxIdDigits(value?.toString());
    if (!digits) return true; // Optional field
    return TAX_ID_DIGITS_REGEX.test(digits);
}

/**
 * Normalizes a tax ID to the 9-digit format required by Stedi.
 * @param value - The tax ID value
 * @returns 9-digit string or empty string if invalid/empty
 */
export function normalizeTaxId(value: string | null | undefined): string {
    const digits = getTaxIdDigits(value);
    return digits.length === 9 ? digits : '';
}

export default taxIdValid;
